import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlidesWide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="slides-wide"><path fillRule="evenodd" clipRule="evenodd" d="M2 4.75C2 4.33579 2.33579 4 2.75 4H17.25C17.6642 4 18 4.33579 18 4.75V8H21.25C21.6642 8 22 8.33579 22 8.75V19.25C22 19.6642 21.6642 20 21.25 20H6.75C6.33579 20 6 19.6642 6 19.25V16H2.75C2.33579 16 2 15.6642 2 15.25V4.75ZM6 8.75V14.5H3.5V5.5H16.5V8H6.75C6.33579 8 6 8.33579 6 8.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSlidesWide;
